/**
 * BountySubmissionsPage: bounty-owner view of pending (validated) submissions for
 * one of their listings, rendered at /account/listings/:bountyId (nested under
 * UserHomepage). Pure composition, no local state or API calls: shows
 * pages/bounty/SubheadedBountyDisplay (type="owner") above a
 * components/ItemCollection of type "bounty-submissions" wrapped in SubheadedPage.
 */
import { SubheadedPage } from "@/components/SubheadedPage";
import ItemCollection from "@/components/ItemCollection";
import SubheadedBountyDisplay from "@/pages/bounty/SubheadedBountyDisplay";

const BountySubmissionsPage: React.FC = () => {
    return (
        <div className="flex flex-col w-full pb-16">
            <SubheadedBountyDisplay type="owner" />
            <SubheadedPage heading={`pending submissions`}>
                <ItemCollection
                    type="bounty-submissions"
                    format="row"
                    itemType="submission"
                    statusType="validated"
                />
            </SubheadedPage>
        </div>
    );
};

export default BountySubmissionsPage;
